import React from 'react';
import { vpsData } from "../../assets/data/vpsData";

const PlanStep = ({
  selectedPlan,
  setSelectedPlan,
  selectedOS,
  setSelectedOS,
  variants,
  selectedVariant,
  setSelectedVariant,
  variantLabel,
  billingCycle,
  setBillingCycle,
  quantity,
  setQuantity,
  type
}) => {
  const isStorage = type === "storage";
  const plans = vpsData.filter((p) => p.type === type);

  return (
    <div className="space-y-3.5 animation-fade-in text-sm">
      <div>
        <label className="block mb-1 font-medium text-gray-300 text-xs">
          {isStorage ? "Cloud Storage Plan *" : "VPS Plan *"}
        </label>
        <select
          value={selectedPlan}
          onChange={(e) => setSelectedPlan(e.target.value)}
          className="w-full bg-[#022A52] border border-[#033A6A] focus:border-blue-500 rounded-lg p-2 text-white text-sm outline-none transition"
        >
          <option value="">Select a plan</option>
          {plans.map((p) => (
            <option key={p.plan} value={p.plan}>
              {isStorage ? `${p.plan} (${p.storage})` : `${p.plan} (${p.cpu}, ${p.ram}, ${p.storage})`}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block mb-1 font-medium text-gray-300 text-xs">Operating System *</label>
        <select
          value={selectedOS}
          onChange={(e) => setSelectedOS(e.target.value)}
          className="w-full bg-[#022A52] border border-[#033A6A] focus:border-blue-500 rounded-lg p-2 text-white text-sm outline-none transition"
        >
          <option value="Linux">Linux</option>
          <option value="Windows">Windows</option>
        </select>
      </div>

      {variants.length > 0 && (
        <div>
          <label className="block mb-1 font-medium text-gray-300 text-xs">{variantLabel} *</label>
          <select
            value={selectedVariant}
            onChange={(e) => setSelectedVariant(e.target.value)}
            className="w-full bg-[#022A52] border border-[#033A6A] focus:border-blue-500 rounded-lg p-2 text-white text-sm outline-none transition"
          >
            {variants.map((v) => (
              <option key={v} value={v}>{v}</option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label className="block mb-1 font-medium text-gray-300 text-xs">Billing Cycle *</label>
        <select
          value={billingCycle}
          onChange={(e) => setBillingCycle(e.target.value)}
          className="w-full bg-[#022A52] border border-[#033A6A] focus:border-blue-500 rounded-lg p-2 text-white text-sm outline-none transition"
        >
          <option value="Monthly">Monthly</option>
          <option value="Quarterly">Quarterly</option>
          <option value="Annually">Annually</option>
        </select>
      </div>

      <div>
        <label className="block mb-1 font-medium text-gray-300 text-xs">Instance Quantity *</label>
        <input
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
          min="1"
          className="w-full bg-[#022A52] border border-[#033A6A] focus:border-blue-500 rounded-lg p-2 text-white text-sm outline-none transition"
        />
      </div>
    </div>
  );
};

export default PlanStep;